import { render } from "./patchApplication.vue?vue&type=template&id=d9c15bc8"
import script from "./patchApplication.vue?vue&type=script&lang=js"
export * from "./patchApplication.vue?vue&type=script&lang=js"

import "./patchApplication.vue?vue&type=style&index=0&id=d9c15bc8&lang=scss"

import exportComponent from "D:\\JYC\\产品源码\\前端\\工作流引擎\\stgd.oa.mobile.h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__